/**
 * Product appearance modes. Extend THEME_IDS when adding sepia / intensity later.
 * Persist key is shared across marketing + authenticated shells.
 */
export const THEME_STORAGE_KEY = 'oikra-theme';

export const THEME_IDS = Object.freeze(['light', 'dark']);

export const DEFAULT_THEME = 'light';

export function isThemeId(value) {
  return THEME_IDS.includes(value);
}

export function readStoredTheme() {
  try {
    const raw = localStorage.getItem(THEME_STORAGE_KEY);
    if (isThemeId(raw)) return raw;
  } catch {
    /* private mode / SSR */
  }
  return DEFAULT_THEME;
}

/** Apply theme on <html> for FOUC + overscroll; update theme-color meta. */
export function applyDocumentTheme(theme) {
  const next = isThemeId(theme) ? theme : DEFAULT_THEME;
  if (typeof document === 'undefined') return next;
  const root = document.documentElement;
  root.setAttribute('data-theme', next);
  root.style.colorScheme = next;
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) {
    meta.setAttribute('content', next === 'dark' ? '#0e1526' : '#f7f6f2');
  }
  return next;
}

export function persistTheme(theme) {
  const next = isThemeId(theme) ? theme : DEFAULT_THEME;
  try {
    localStorage.setItem(THEME_STORAGE_KEY, next);
  } catch {
    /* ignore */
  }
  return next;
}
